import React from 'react';
import Container from '../Container';
import Content from '../Content';
import ComplainForm from './ComplainForm';

function Complain(props) {
    return (
        <Container>

        <Content>
         

       <ComplainForm/>
        </Content>
    </Container>
    );
}

export default Complain;